import React from 'react';
import { Box, Card, styled, useTheme } from '@mui/material';
import ChartContent, { ChartContentData } from '../ChartContent';
import { colors } from '../../../utils/palette';

export interface ChartWrapperProps {
  components: ChartContentData[];
  isLoading?: boolean;
  isError?: boolean;
  customPadding?: { top: number; right: number; bottom: number; left: number };
  noWrapperStyle?: boolean;
  noBoxShadow?: boolean;
}

const ChartWrapper: React.FC<ChartWrapperProps> = ({ components, isLoading, isError, customPadding, noWrapperStyle, noBoxShadow }) => {
  const listOfNoBowShadowComponents = ['progressChart', 'tinyLineChart'];
  const isNoBoxShadow = noBoxShadow || listOfNoBowShadowComponents.some((component) => components[0]?.chart.type === component);
  const theme = useTheme();

  return (
    <ChartWrapperCard
      paddingbottom={customPadding?.bottom !== undefined ? `${String(customPadding.bottom)}px` : theme.spacing(3)}
      paddingtop={customPadding?.top !== undefined ? `${String(customPadding.top)}px` : theme.spacing(3)}
      paddingleft={customPadding?.left !== undefined ? `${String(customPadding.left)}px` : theme.spacing(3)}
      paddingright={customPadding?.right !== undefined ? `${String(customPadding.right)}px` : theme.spacing(3)}
      nowrapperstyle={noWrapperStyle ? 'true' : 'false'}
      noboxshadow={isNoBoxShadow ? 'true' : 'false'}
    >
      <Box component="div" data-testid="chart-wrapper">
        <ChartContent components={components} isLoading={isLoading} isError={isError} noWrapperStyle={noWrapperStyle} />
      </Box>
    </ChartWrapperCard>
  );
};

export default ChartWrapper;

const ChartWrapperCard = styled(Card)<{
  paddingtop: string;
  paddingbottom: string;
  paddingleft: string;
  paddingright: string;
  nowrapperstyle: 'true' | 'false';
  noboxshadow: 'true' | 'false';
}>(({ theme, paddingtop, paddingbottom, paddingleft, paddingright, nowrapperstyle, noboxshadow }) => ({
  width: nowrapperstyle === 'true' ? 'fit-content' : '100%',
  height: nowrapperstyle === 'true' ? 'fit-content' : '100%',
  boxShadow: nowrapperstyle === 'true' || noboxshadow === 'true' ? 'none' : 'rgba(216, 210, 218, 0.25) 0px 10px 20px -8px',
  '&>div': {
    borderRadius: theme.spacing(0.5),
    backgroundColor: colors.white,
    width: '100%',
    paddingTop: paddingtop,
    paddingRight: paddingright,
    paddingBottom: paddingbottom,
    paddingLeft: paddingleft,
    height: '100%',
  },
}));
